import React, { Component } from "react";

import { CButton } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import "./styles.css";
import { logout } from "../../../../actions/baseActions";
import { setLayout } from "../../../../actions/layoutActions";
import { setObj } from "../../../../actions/noteActions";
import ImgNoData from "../../../../assets/imgs/graduation.svg";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class QuestionListDo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      execution_id: undefined,
      activity_id: this.props.match.params.activity_id,
      allocation_id: undefined,
      item_id: undefined,
      list_id: undefined,
      result_type: undefined,
      activity_end: undefined,
      time: undefined,
      execution_quantity: undefined,
      hasAble: true,
      isTrailActivity: false
    };
  }

  componentDidMount() {
    this.setState({ activity_id: this.props.match.params.activity_id });
    (async () => {
      const currentUrl = window.location.href;
      const queryString = currentUrl.split("?")[1];

      if (queryString) {
        const params = queryString.split("&");
        const paramMap = {};

        params.forEach(param => {
          const [key, value] = param.split("=");
          paramMap[key] = decodeURIComponent(value);
        });

        const itemId = paramMap?.itemid;
        const listId = paramMap?.listid;

        if (itemId && listId) {
          this.setState(
            {
              item_id: itemId,
              list_id: listId,
              isTrailActivity: true
            },
            async () => {
              await this.createExecutionWithActivityId();
              await this.getList(listId);
            }
          );
        }
        this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
      } else {
        await this.getContent();
      }
    })();
  }

  async getContent() {
    (async () => {
      const allocationResponse = await this.findAllocation();
      await this.getAllocation(allocationResponse?.allocation_id);
      await this.getList(allocationResponse?.list_id);
      await this.createExecutionWithAllocationId();

      this.setState({ loading: false });
    })();
  }

  async createExecutionWithAllocationId() {
    const response = await axios.post(
      `${URL.api}activity/execution/insertByAllocation`,
      // eslint-disable-next-line react/no-access-state-in-setstate
      { allocation_id: this.state.allocation_id },
      {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );
    this.setState({ execution_id: response.data.data });
  }

  async findAllocation() {
    const allocationResponse = await axios.get(
      `${URL.api}activity/allocation/find`,
      {
        // eslint-disable-next-line react/no-access-state-in-setstate
        params: { activity_id: this.state.activity_id },
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );

    this.setState({
      allocation_id: allocationResponse.data.data.allocation_id,
      item_id: allocationResponse.data.data.item_id,
      list_id: allocationResponse.data.data.list_id
    });
    return allocationResponse.data?.data;
  }

  async createExecutionWithActivityId() {
    const response = await axios.post(
      `${URL.api}activity/execution/insert`,
      // eslint-disable-next-line react/no-access-state-in-setstate
      { activity_id: this.state.activity_id },
      {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );
    this.setState({ execution_id: response.data.data });
  }

  async getList(listId) {
    this.setState({
      loading: true
    });
    const response = await axios.get(
      // eslint-disable-next-line react/no-access-state-in-setstate
      `${URL.api}evaluation/question/lists/singleView/${listId}`,
      {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );
    this.setState({
      time: response.data.data.time,
      execution_quantity: response.data.data.execution_quantity,
      loading: false
    });
  }

  async getAllocation(allocationId) {
    const response = await axios.get(
      // eslint-disable-next-line react/no-access-state-in-setstate
      `${URL.api}activity/activity/singleViewByAllocation/${allocationId}`,
      {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Origin": "*"
        }
      }
    );

    this.setState({
      activity_end: response.data.data.activity_end,
      result_type: response.data.data.result_type,
      loading: false
    });
  }

  render() {
    return (
      <div className="main-list-content pt-3 pb-5">
        {this.state.loading ? (
          <Loading />
        ) : (
          <>
            {this.state.hasAble && this.state.list_id ? (
              <div className="h-100 w-100 aql-execution-container">
                <ApplicatedQuestionList
                  currentItem={this.props.currentItem}
                  updateCompletionItem={this.props.updateCompletionItem}
                  executionQuantity={this.state.execution_quantity}
                  activityId={this.state.activity_id}
                  currentRoute={this.props.currentRoute}
                  allocation_id={this.state.allocation_id}
                  id={this.state.list_id}
                  history={this.props.history}
                  prototype={false}
                  item_id={this.state.item_id}
                  execution_id={this.state.execution_id}
                  result_type={this.state.result_type}
                  ended={false}
                  time={this.state.time}
                  close={async () => {
                    if (this.state.isTrailActivity) {
                      await this.createExecutionWithActivityId();
                    } else {
                      await this.createExecutionWithAllocationId();
                    }
                  }}
                  noClose
                  end_date={this.state.activity_end}
                  isTrailActivity={this.state.isTrailActivity}
                />
              </div>
            ) : (
              <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                <img
                  src={ImgNoData}
                  style={{ height: "240px", marginBottom: "2rem" }}
                  alt=""
                />
                <p
                  style={{ fontSize: "1.5rem" }}
                  className="mb-2 font-weight-bold text-center"
                >
                  A atividade não foi liberada para você!
                </p>
                <span className="text-muted text-center">
                  Tente voltar daqui a alguns minutos
                </span>
              </div>
            )}
            <ProtectedRoute routeId={this.props.currentRoute} />
          </>
        )}
      </div>
    );
  }
}

QuestionListDo.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

QuestionListDo.defaultProps = {
  hideLayout: true,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionListDo);
